// extracted by mini-css-extract-plugin
export default {"cardHover":"Industry_cardHover__ucrnu","imageContainer":"Industry_imageContainer__-B8VL","cardImage":"Industry_cardImage__933wm"};